<template>
  <span v-if="props.anchor" :id="props.anchor" class="anchor"></span>
  <div class="card" v-bind="$attrs">
    <div class="card-header d-flex justify-content-between bg-primary">
      <h4 class="text-uppercase mb-0">Pages supplémentaires</h4>
      <button class="btn btn-link link-dark p-0 link-underline-opacity-0 link-underline-opacity-100-hover" @click="addPage()"><i class="fa-solid fa-plus pe-1"></i>Ajouter une page</button>
    </div>
        <div class="card-body">
      <div v-if="pages.length === 0" class="text-muted">
        Aucune page supplémentaire
      </div>
      <div v-else v-for="(page,idx) in pages" :key="page.key" class="card mb-3">
        <span :id="`pages[${idx}]`" class="anchor"></span>
        <div class="card-header d-flex justify-content-between bg-primary bg-opacity-25">
          <h4 class="text-uppercase mb-0">{{page.value?.title.length > 0 ? page.value?.title : `Page ${idx + 1}`}}</h4>
          <button class="btn btn-link link-dark p-0" @click="removePage(idx)"><i class="fa-regular fa-trash-can fa-lg"></i></button>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-6">
              <TextInputComponent
                :value-key="`pages[${idx}].title`"
                label="Titre"
                placeholder="Titre de la page"
                :required="true"
                class="mb-3"
              />
            </div>
            <div class="col-12 col-md-6">
              <TextInputComponent
                :value-key="`pages[${idx}].labelIcon`"
                label="Texte de l'icône de navigation"
                placeholder="Texte de l'icône de navigation"
                :required="false"
                class="mb-3"
              />
            </div>
            <div class="col-12">
              <RichTextComponent
                :value-key="`pages[${idx}].content`"
                label="Contenu de la page"
                placeholder="Contenu de la page"
                :required="true"
                class="mb-3"
              />
            </div>
            <div class="col-6">
              <CheckboxComponent
                :value-key="`pages[${idx}].hideDuringInscription`"
                label="Cacher la page pendant l'inscription ?"
              />
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useFieldArray } from 'vee-validate';
import TextInputComponent from '@/components/common/TextInputComponent.vue';
import RichTextComponent from '@/components/common/RichTextComponent.vue';

import { IdNotDefined, ScrollToId } from '@/compositions/helper';
import * as zod from 'zod';

const validationSchema = defineModel<{ shape: zod.ZodRawShape, anchors?: Record<string, string | undefined> }>('validation-schema',{ required: false, default: () => ({ shape: {} }) });

const props = defineProps<{
  anchor?: string
}>();

const { remove: removePage, push: pushPage, fields: pages } = useFieldArray<TravelDbPage>(() => 'pages');

const defaultPage = <TravelDbPage>{
  id: IdNotDefined,
  title: '',
  labelIcon: '',
  content: '',
  hideDuringInscription: false
}

const newPage = ref<TravelDbPage>(Object.assign({}, defaultPage));

const addPage = () => {
  pushPage(newPage.value);
  newPage.value = Object.assign({}, defaultPage);
  ScrollToId(`pages[${(pages.value.length ?? 1) - 1}]`);
}

onMounted(() => {
  validationSchema.value = {
    shape:{
      pages: zod.array(zod.object({
        id: zod.number().nonnegative(),
        title: zod.string(),
        labelIcon: zod.string().optional(),
        content: zod.string(),
        hideDuringInscription: zod.boolean({ message: 'Le choix de cacher ou non la page pendant l\'inscription est obligatoire' })
      }).optional()
    ).optional()
    },
    anchors: {
      "pages": props.anchor,
      "pages[\\d].id": "self",
      "pages[\\d].title": "self",
      "pages[\\d].labelIcon": "self",
      "pages[\\d].content": "self",
      "pages[\\d].hideDuringInscription": "self",
    }
  }
});
</script>
